import { render } from "./ReadyBatch.vue?vue&type=template&id=2b839356"
import script from "./ReadyBatch.vue?vue&type=script&lang=js"
export * from "./ReadyBatch.vue?vue&type=script&lang=js"
script.render = render

export default script